import React, {Component} from 'react'
import {connect} from 'react-redux'
import {TimeStream} from '../../utils'
import logo from '../../images/logo.png'


class ClassroomDiscussRobot extends Component {
    COMPLAIN_WORDS = ['投诉', '退款', '诈骗', '骗人', '色情', '垃圾', '骗子', '骗钱']
    GREAT_WORDS = ['老师好厉害', '老师好棒', '谢谢老师', '老师好赞', '受教了', '老师老厉害了', '感谢老师']
    BAD_WORDS = ['还没开始吗', '还不开始吗', '老师呢', '要等多久', '什么时候开课', '不讲课', '没内容', '老师什么时候来', '课程什么时候开始']

    constructor() {
        super()
        this.handleFilterDiscuss = this.handleFilterDiscuss.bind(this)
    }

    handleFilterDiscuss(discuss) {
        const {lecture, role} = this.props

        this.COMPLAIN_WORDS.map((item) => {
            let re = new RegExp(item)
            if (re.test(discuss)) {
                setTimeout(() => {
                    this.props.dispatch({
                        type: 'ROBOT_COMPLAIN',
                        payload: {
                            time: TimeStream(lecture.start_timestamp)
                        }
                    })
                }, 1000)
                return
            }
        })

        this.GREAT_WORDS.map((item) => {
            let re = new RegExp(item)
            if (re.test(discuss)) {
                setTimeout(() => {
                    this.props.dispatch({type: 'ROBOT_GREAT'})
                }, 1000)
                return
            }
        })

        const tsNow = parseInt(Date.now() / 1000, 10)
        this.BAD_WORDS.map((item) => {
            let re = new RegExp(item)
            if (re.test(discuss)) {
                if (lecture.start_timestamp > tsNow && !role.is_manager) {
                    setTimeout(() => {
                        this.props.dispatch({
                            type: 'ROBOT_BAD_NO_BEGIN',
                            payload: {
                                time: TimeStream(lecture.start_timestamp)
                            }
                        })
                    }, 1000)
                } else {
                    setTimeout(() => {
                        this.props.dispatch({
                            type: 'ROBOT_BAD_BEGIN',
                            payload: {
                                time: TimeStream(lecture.start_timestamp)
                            }
                        })
                    }, 1000)
                }
                return
            }
        })
    }

    componentDidMount() {
        const {lecture, role, subscribed} = this.props
        const tsNow = parseInt(Date.now() / 1000, 10)
        if (lecture.start_timestamp > tsNow && !role.is_manager) {
            if (!(subscribed && role.is_fans)) {
                this.props.dispatch({
                    type: 'ROBOT_NO_SUBSCRIBED',
                    payload: {
                        time: TimeStream(lecture.start_timestamp)
                    }
                })
            } else {
                this.props.dispatch({
                    type: 'ROBOT_SUBSCRIBED',
                    payload: {
                        time: TimeStream(lecture.start_timestamp)
                    }
                })
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.role.is_fans !== prevProps.role.is_fans) {
            return
        }
        const {robot} = this.props
        const discuss = {
            type: 'discuss_text',
            published: false,
            content: robot.content,
            account: {
                id: Date.now() * 0.001,
                small_avatar_url: logo,
                avatar_url: logo,
                nickname: '弹幕小助手'
            },
            id: Date.now() * 0.001,
            timestamp: Date.now() * 0.001
        };

        if (robot.robotAction === 'ROBOT_SET_DISCUSS') {
            this.handleFilterDiscuss(robot.lastDiscuss.content)
        } else {
            if (robot.content) {
                this.props.dispatch({
                    type: 'POPUP_RECEIVE',
                    payload: discuss
                });
            }
        }
    }

    render() {
        return null
    }
}

export default connect((state) => ({
    robot: state.robot,
    isPopupInit: state.popupList.isPopupInit,
    role: state.classroom.role,
    lecture: state.classroom.lecture,
    subscribed: state.account.subscribed,
}))(ClassroomDiscussRobot)


// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomDiscussRobot.js